import { render, staticRenderFns } from "./materials-tab.vue?vue&type=template&id=0875aaeb"
import script from "./materials-tab.vue?vue&type=script&lang=js"
export * from "./materials-tab.vue?vue&type=script&lang=js"
import style0 from "./materials-tab.vue?vue&type=style&index=0&id=0875aaeb&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports